import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export function Card({
  children,
  className,
  padding = 'md',
  interactive = false,
  variant = 'default',
}: {
  children: ReactNode
  className?: string
  padding?: 'none' | 'sm' | 'md' | 'lg'
  /** Hover lift + cursor — pl. clickable list-itemek. */
  interactive?: boolean
  /** `accent` = subtle brand-gradient háttér; `flat` = nincs shadow. */
  variant?: 'default' | 'accent' | 'flat'
}) {
  const p = padding === 'none' ? '' : padding === 'sm' ? 'p-3' : padding === 'lg' ? 'p-6' : 'p-4'
  return (
    <div
      className={cn(
        'rounded-xl2 border',
        variant === 'default' &&
          'bg-white border-slate-200/80 shadow-panel dark:bg-slate-900/60 dark:border-slate-800',
        variant === 'accent' &&
          'border-brand-200/60 bg-brand-fade shadow-card dark:border-brand-900/40 dark:bg-brand-fade-dark',
        variant === 'flat' &&
          'bg-white border-slate-200/80 dark:bg-slate-900/40 dark:border-slate-800',
        interactive &&
          'transition-all duration-200 ease-out-soft cursor-pointer hover:shadow-lift hover:-translate-y-0.5 hover:border-brand-300/60 dark:hover:border-brand-700/60',
        p,
        className,
      )}
    >
      {children}
    </div>
  )
}

export function CardHeader({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('mb-3 flex items-start justify-between gap-3', className)}>{children}</div>
}

export function CardTitle({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <h3 className={cn('text-sm font-semibold text-slate-900 dark:text-slate-100 tracking-tightish', className)}>
      {children}
    </h3>
  )
}

export function CardSubtitle({ children, className }: { children: ReactNode; className?: string }) {
  return <p className={cn('text-xs text-slate-500 dark:text-slate-400 mt-0.5', className)}>{children}</p>
}
